import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description FileCrossOut icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { FileCrossOut } from '@sravni/design-system-icons'
 *
 * <FileCrossOut />
 * ```
 */
var FileCrossOut = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "FileCrossOut", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4.667 6.667v9.166c0 .921.746 1.667 1.667 1.667H13M16.333 13.333v-6.81c0-.441-.175-.865-.488-1.178l-2.357-2.357A1.667 1.667 0 0 0 12.31 2.5H8", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M16.334 17.292 4.667 2.708", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { FileCrossOut };
//# sourceMappingURL=FileCrossOut.js.map
